<template>
  <div>
    <v-container fluid class="px-15 pb-10 pt-4">
      <v-row class="ma-0 mt-5 mb-4">
        <v-col class="pa-0 my-4">
          <div style="font-family: 'montserrat-bold'; font-size: 32px; color: #000000;">{{ "Usuarios" }}</div>
          <div style="font-family: 'montserrat-regular'; font-size: 14px;"> {{ "Aqui encontraras los datos de los usuarios registrados." }}</div>
        </v-col>
      </v-row>
      <v-row justify="start" align="center" class="d-flex ma-0 mb-4">
        <v-col class="d-flex pl-0">
          <div style="width: 286px;">
            <v-text-field
              v-model="busqueda"
              placeholder="Buscar usaurio"
              clearable
              hide-details
              outlined
              style="width: 300px; font-family: 'montserrat-medium'; border-radius: 20px;"
              prepend-inner-icon="mdi-magnify"
            />
          </div>
        </v-col>
        <v-col class="d-flex justify-end pa-0 my-4">
          <v-btn color="#000000" :disabled="!canCreateUser" elevation="8" class="white--text ml-4" style="border-radius: 36px; border: 2px solid #000000; font-family: 'montserrat-semibold'; text-transform: none;">
            {{ "Crear Usuario" }}
          </v-btn>
          <v-btn color="#000000" :disabled="true" elevation="8" class="white--text ml-4" style="border-radius: 36px; border: 2px solid #000000; font-family: 'montserrat-semibold'; text-transform: none;" @click="dataXLSX()">
            <v-img class="mr-2" src="../assets/icons/Vector.svg" style="width: 14px;"></v-img>
            {{ "Descargar" }}
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table class="d-none d-sm-block" hide-default-header :items="filteredItems">
        <template v-slot:header="{ props }">
          <thead style="background-color: #f9fafd;">
            <tr>                                                                                                                                      
              <th class="header__title left">{{ "Nombre" }}</th>                                                                                                                                    
              <th class="header__title center">{{ "Email" }}</th>
              <th class="header__title center">{{ "Empresa" }}</th>   
              <th class="header__title center">{{ "Credits" }}</th>   
              <th class="header__title center">{{ "Activo" }}</th>    
              <th class="header__title center">{{ "Acceso Plataforma" }}</th>  
              <th class="header__title right">{{ "Acciones" }}</th>
            </tr>
          </thead>
        </template>
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr v-for="item in items" :key="item.id">
              <td class="table__item">{{ item.sName }}</td>
              <td class="table__item">{{ item.sEmail }}</td>
              <td class="table__item">{{ item.sEnterpriseName }}</td>
              <td class="table__item">{{ item.creditos }}</td>
              <td class="table__item">
                <v-chip
                  class="ma-2"
                  :color="item.active == 'Active' ? 'green' : 'red'"
                  outlined
                >
                  {{ item.active }}
                </v-chip>
              </td>
              <td class="table__item">
                <v-chip
                  class="ma-2"
                  :color="item.bPlatformAccess == 'Active' ? 'green' : 'red'"
                  outlined
                >
                  {{ item.bPlatformAccess }}
                </v-chip>
              </td>
              <td class="table__item">
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn :disabled="true" v-bind="attrs" v-on="on" icon color="black">
                      <v-icon left>mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>Descargar comprobante</span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
      <v-data-table class="d-sm-none d-block" hide-default-header :items="filteredItems">
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd; ">
            <tr style="display: flex; flex-direction: column;" v-for="item in items" :key="item.id">
              <td class="table__item__mobile">
                <div>{{ "Nombre" }}</div>
                <div>{{ item.sName }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Email" }}</div>
                <div>{{ item.sEmail }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Empresa" }}</div>
                <div>{{ item.sEnterpriseName }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Credits" }}</div>
                <div>{{ item.creditos }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Activo" }}</div>
                <div>
                  <v-chip
                    class="ma-2"
                    :color="item.active == 'Active' ? 'green' : 'red'"
                    outlined
                  >
                    {{ item.active }}
                  </v-chip>
                </div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Acceso Plataforma" }}</div>
                <div>
                  <v-chip
                    class="ma-2"
                    :color="item.bPlatformAccess == 'Active' ? 'green' : 'red'"
                    outlined
                  >
                    {{ item.bPlatformAccess }}
                  </v-chip>
                </div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Acciones" }}</div>
                <div>
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn :disabled="true" v-bind="attrs" v-on="on" icon color="black">
                        <v-icon>mdi-eye</v-icon>
                      </v-btn>
                    </template>
                    <span>Detalle</span>
                  </v-tooltip>
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
  import moment from "moment";
  import { saveAs } from "file-saver";
  import * as XLSX from "xlsx";
  import { mapGetters } from "vuex";

  export default {
    name: "DashboardView",
    data() {
      return {
        items: [],
        busqueda: "",
        loading: false,
        nameXLSX: "",
      };
    },
    methods: {
      getUsers() {
        this.loading = true;
        this.items = [];
        DB.get(`${URI}/api/v1/en/administrator/allUsers`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        }).then((response) => {
          this.loading = false;
          this.items = response.data.results.map((item) => {
            return {
              sName: item.sName + " " + item.sLastname,
              sEmail: item.sEmail,
              sEnterpriseName: item.sEnterpriseName,
              creditos: item.credit,
              active: item.bActive ? "Active" : "Inactive",
              bPlatformAccess: item.bPlatformAccess ? "Active" : "Inactive",
              originalItem: item,
            };
          });
        }).catch((error) => {
          if (error.response.data.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(error.response.data.message, error.response.status);
        });
      },
      dataXLSX() {
        try {
          let data = this.items.map((item) => {
            return {
              Name: item.sName + " " + item.sLastname,
              Email: item.sEmail,
              Empresa: item.sEnterpriseName,
              Creditos: item.credit,
              Activo: item.bActive ? "Active" : "Inactive",
              "Acceso a la plataforma": item.bPlatformAccess ? "Active" : "Inactive",
            };
          });
          const worksheet = XLSX.utils.json_to_sheet(data);

          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Hoja1");

          const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

          const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

          const date = moment().format("YYYY-MM-DD HH:mm");
          this.nameXLSX = `Wallets_${date}.xlsx`;
          saveAs(blob, this.nameXLSX);
          this.success = true;
          this.msgSuccess = "Descargando documento";
        } catch (error) {
          this.error = true;
          this.codeError = "CSV_NO_DATA";
        }
      },
    },
    computed: {
      ...mapGetters(['hasPermission']),
      canCreateUser() {
        return this.hasPermission('7e6b9156-0faa-4278-b0bb-909e6897972c');
      },
      filteredItems() {
        if (!this.busqueda) return this.items;

        const texto = this.busqueda.toLowerCase();
        return this.items.filter(item => {
          const nombre = item.sName?.toLowerCase() || "";
          const mail = item.sEmail?.toLowerCase() || "";
          const empresa = item.sEnterpriseName?.toLowerCase() || "";

          return (
            nombre.includes(texto) ||
            mail.includes(texto) ||
            empresa.includes(texto) 
          );
        });
      }
    },
    beforeMount() {
      this.getUsers();
    },
  };
</script>

<style>
</style>
